import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Memed from "./Components/Memed";
import * as Actions from "./Store/Actions/MarketplaceActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = () => ({
   root: {},
});

const NewState = {
   idintegracao: null,
   idpessoa: null,
   idpessoaformulario: null,
   usuario: null,
   tipo: -1,
   setup: {},
};

class MarketplaceDialog extends XAPPComponent {
   state = { ...NewState };

   componentDidUpdate(prevProps) {
      if (this.props.Marketplace.error) {
         this.props.showMessage({
            message: this.props.Marketplace.error,
            variant: "error",
         });
         this.props.Marketplace.error = null;
      }
      if (this.props.Marketplace.warning) {
         this.props.showMessage({
            message: this.props.Marketplace.warning,
            variant: "warning",
         });
         this.props.Marketplace.warning = null;
      }
      if (this.props.Marketplace.info) {
         this.props.showMessage({
            message: this.props.Marketplace.info,
            variant: "success",
         });
         this.props.Marketplace.info = null;
         this.props.openDialog();
      }

      const { open = null, Marketplace, user, clearReducer, xappRouteParams } = this.props;

      if (!_.isNull(open) && !_.isEqual(prevProps.open, open)) {
         this.setState({
            ...NewState,
            ...user.settings.empresapessoaformulario[xappRouteParams.empresa],
            usuario: user.usuario,
            tipo: open.tipo,
            idpessoa: xappRouteParams.empresa,
            setup: {},
         });
      }

      if (!_.isNull(open) && !_.isNull(Marketplace.data) && !_.isEqual(prevProps.Marketplace.data, Marketplace.data)) {
         this.setState({ ...Marketplace.data });
      }

      if (_.isNull(open) && !_.isEqual(prevProps.open, open)) {
         this.setState(NewState);
         clearReducer();
      }

      if (!_.isNull(open) && !_.isNull(Marketplace.responseIntegracao) && !_.isEqual(prevProps.Marketplace.responseIntegracao, Marketplace.responseIntegracao)) {
         this.setState({ setup: { ...this.state.setup, ...Marketplace.responseIntegracao } });
      }
   }

   handleChange = (event) => {
      this.setState({ setup: _.set({ ...this.state.setup }, event.target.name, event.target.value) });
   };

   canBeSubmitted = () => {
      const { open = null } = this.props;
      const form = this.state;
      let AResponse = true;
      if (!_.isNull(open) && !_.isUndefined(open.formulario)) {
         open.formulario.forEach((item) => {
            if (AResponse && !_.isUndefined(item.id) && (_.isUndefined(form.setup[item.id]) || _.isNull(form.setup[item.id]) || form.setup[item.id].length < 1)) {
               AResponse = false;
            }
         });

         if (AResponse && !open.empresa) {
            AResponse = !_.isUndefined(form.idpessoaformulario) && !_.isNull(form.idpessoaformulario);
         }
      }
      return AResponse;
   };

   render() {
      const { save, xappRouteParams, open = null, openDialog, user, integracao, isButton = false, callback } = this.props;
      const form = this.state;
      return (
         <React.Fragment>
            <XAPPDialog
               id="Marketplace"
               open={!_.isNull(open)}
               onClose={() => openDialog()}
               fullWidth
               fullScreen={md.mobile() !== null}
               maxWidth={md.mobile() === null && md.tablet() === null && "md"}
            >
               <AppBar position="static" elevation={1}>
                  <Toolbar className="flex w-full min-h-0">
                     <Typography variant="subtitle1 text-white">{"Configurar integração"}</Typography>
                     <div style={{ flex: 1 }} />
                     <IconButton key="close" aria-label="Close" className="p-6" onClick={() => openDialog()}>
                        <MdClose className="text-20 text-white" />
                     </IconButton>
                  </Toolbar>
               </AppBar>
               <DialogContent className="p-12">
                  {!_.isNull(open) && (
                     <React.Fragment>
                        {!open.empresa && (
                           <EmpresaPessoaApp
                              className="w-full flex flex-col mb-12"
                              xappRouteParams={xappRouteParams}
                              target="spvwempresapessoafuncionario"
                              selected={!_.isNull(form.idpessoaformulario) ? [{ id: form.idpessoaformulario, nome: form.nome }] : []}
                              label={"Profissional"}
                              id={"LookupProfissionalIntegracao"}
                              campoid={"idpessoaformulario"}
                              required={true}
                              camponome={"nome"}
                              onChange={(_AValue) => {
                                 this.setState({
                                    nome: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.nome : null,
                                    idpessoaformulario: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].idpessoaformulario : null,
                                    usuario: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.uid : null,
                                    registroconselho: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.registroconselho : null,
                                    registroconselhouf: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.registroconselhouf : null,
                                    documentoprimario: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.documentoprimario : null,
                                    fone: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.fone : null,
                                    email: !_.isNull(_AValue) && _AValue.length > 0 ? _AValue[0].formulario.email : null,
                                    setup: {}
                                 });
                              }}
                              isLookup={true}
                              multiSelect={false}
                           />
                        )}
                        {!_.isUndefined(open.formulario) &&
                           open.formulario.map((item) => {
                              switch (item.component) {
                                 case "textfield": {
                                    return (
                                       <TextField
                                          className="mb-12"
                                          label={item.label}
                                          id={item.id}
                                          name={item.id}
                                          value={!_.isUndefined(form.setup[item.id]) ? form.setup[item.id] : ""}
                                          onChange={this.handleChange}
                                          variant="outlined"
                                          fullWidth
                                          required
                                          disabled={item.disabled}
                                          InputLabelProps={{
                                             shrink: true,
                                          }}
                                       />
                                    );
                                 }
                                 case "memed": {
                                    return (
                                       <Memed
                                          data={form}
                                          xappRouteParams={xappRouteParams}
                                          integracao={integracao}
                                       />
                                    );
                                 }
                                 default:
                                    return null;
                              }
                           })}
                     </React.Fragment>
                  )}
               </DialogContent>
               <AppBar position="static" elevation={3} color="textSecondary">
                  <Toolbar className="flex w-full justify-end min-h-0 px-8">
                     <DialogActions>
                        {user.usuario === form.usuario && !isButton ? (
                           <ConfirmacaoApp
                              id="btnSalvarIntegracaoConfirmacao"
                              data=""
                              type="button"
                              onConfirmation={() => save(form, xappRouteParams, !_.isNull(form.idintegracao) ? "ATUALIZAR" : "INSERIR", callback)}
                              mensagem={"Para efetivar essas modificações será necessário efetuar o login novamente, confirma?"}
                              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                              icon={"save"}
                              disabled={!this.canBeSubmitted()}
                              label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                              className="bg-green hover:bg-green text-white"
                           />
                        ) : (
                           <XAPPButton
                              id="btnSalvarIntegracao"
                              data=""
                              type="button"
                              onClick={() => save(form, xappRouteParams, !_.isNull(form.idintegracao) ? "ATUALIZAR" : "INSERIR", callback)}
                              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                              icon={"save"}
                              disabled={!this.canBeSubmitted()}
                              label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                              className="bg-green hover:bg-green text-white"
                           />
                        )}
                     </DialogActions>
                  </Toolbar>
               </AppBar>
            </XAPPDialog>
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         integracao: Actions.integracao,
         clearReducer: Actions.clearReducer,
         save: Actions.save,
         showMessage: AppActions.showMessage,
      },
      dispatch
   );
}

function mapStateToProps({ Marketplace, auth }) {
   return {
      Marketplace: Marketplace,
      user: auth.user.data,
   };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceDialog)));
